import React from 'react'
import { useHistory } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { Button } from 'antd'

const BackToOverviewButton = () => {
  const { push } = useHistory()

  return (
    <Button
      className="ml-2"
      onClick={() => {
        push('/overview')
      }}
    >
      <FormattedMessage id="404.goBack" />
      <span className="icm-arrow-up upgrade-btn-text" />
    </Button>
  )
}

export default BackToOverviewButton
